import { useState } from "react";
import { Pencil } from "lucide-react";
import { useLocation } from "react-router";
import { Button } from "@/components/ui/button";
import {
  PageActions,
  PageActionsTrailing,
  PageBreadcrumb,
} from "@/components/atomic-crm/layout/PageActions";
import type { Contact } from "@/components/atomic-crm/types";
import { ConvertLeadButton } from "@/modules/leads/ConvertLeadButton";
import { LeadEditDialog } from "@/modules/leads/LeadEditDialog";
import { CreateProposalButton } from "@/modules/proposals/CreateProposalButton";
import { getLeadsListPath } from "@/app/routing";
import type { LeadStageId } from "@/modules/leads/leadStages";

export const LeadShowActions = ({
  record,
  embedded = false,
  kanbanStage = null,
}: {
  record: Contact;
  embedded?: boolean;
  kanbanStage?: LeadStageId | null;
}) => {
  const location = useLocation();
  const [editOpen, setEditOpen] = useState(false);
  const listPath =
    kanbanStage != null
      ? getLeadsListPath()
      : (location.state?.from ?? getLeadsListPath());
  const backLabel = kanbanStage != null ? "Pipeline" : "Accounts";

  return (
    <>
      <LeadEditDialog
        open={editOpen}
        onOpenChange={setEditOpen}
        contactId={record.id}
      />

      {!embedded ? (
        <PageActions>
          <PageBreadcrumb
            items={[
              { label: backLabel, to: listPath },
              {
                label: [record.first_name, record.last_name]
                  .filter(Boolean)
                  .join(" "),
              },
            ]}
          />
        </PageActions>
      ) : null}

      <PageActionsTrailing>
        <CreateProposalButton
          contactId={record.id}
          companyId={record.company_id}
          variant="secondary"
        />
        <ConvertLeadButton record={record} />
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="h-9 gap-1.5"
          onClick={() => setEditOpen(true)}
        >
          <Pencil className="size-4" />
          Edit
        </Button>
      </PageActionsTrailing>
    </>
  );
};
